import { axiosPostApi } from "./interceptorServices";
import { apiList } from "./apiList";

// Hub / LMBP / sub-LMBP / user filters shared by the dashboard and Order Master.
// The backend only returns options the logged-in user may see.

export const emptyOrderScopeFilters = {
  hubCode: "",
  lmbpCode: "",
  subLmbpCode: "",
  filterUserId: "",
};

export const fetchOrderFilterOptions = async () => {
  try {
    const response = await axiosPostApi(apiList.ORDER_FILTER_OPTIONS, {});
    if (response?.status === 200 && response?.data?.respCode === "00") {
      const { hubs = [], lmbps = [], subLmbps = [], users = [] } =
        response.data.data || {};
      return { hubs, lmbps, subLmbps, users };
    }
  } catch (error) {
    console.error("Error fetching order filter options", error);
  }
  return { hubs: [], lmbps: [], subLmbps: [], users: [] };
};

// Narrows each list to entries that fit the filters chosen above it
// (hub → LMBP → sub-LMBP → user)
export const cascadeOrderFilterOptions = (options, filters) => {
  const { hubs = [], lmbps = [], subLmbps = [], users = [] } = options || {};
  const { hubCode, lmbpCode, subLmbpCode } = filters || {};

  const lmbpList = lmbps.filter((l) => !hubCode || l.hubCode === hubCode);
  const subList = subLmbps.filter(
    (s) =>
      (!hubCode || s.hubCode === hubCode) &&
      (!lmbpCode || s.masterLmbpCode === lmbpCode),
  );

  let codes = null;
  if (subLmbpCode) codes = [subLmbpCode];
  else if (lmbpCode) codes = [lmbpCode, ...subList.map((s) => s.code)];
  else if (hubCode)
    codes = [hubCode, ...lmbpList.map((l) => l.code), ...subList.map((s) => s.code)];
  const userList = codes ? users.filter((u) => codes.includes(u.code)) : users;

  return { hubs, lmbps: lmbpList, subLmbps: subList, users: userList };
};

// Changing a filter clears the ones below it
export const changeOrderScopeFilter = (filters, key, value) => {
  const order = ["hubCode", "lmbpCode", "subLmbpCode", "filterUserId"];
  const next = { ...filters, [key]: value };
  order.slice(order.indexOf(key) + 1).forEach((k) => (next[k] = ""));
  return next;
};

export const orderScopeFilterFields = [
  { key: "hubCode", label: "Hub", list: "hubs", valueKey: "code" },
  { key: "lmbpCode", label: "LMBP", list: "lmbps", valueKey: "code" },
  { key: "subLmbpCode", label: "Sub-LMBP", list: "subLmbps", valueKey: "code" },
  { key: "filterUserId", label: "User", list: "users", valueKey: "userId" },
];

export const orderScopeOptionLabel = (item, valueKey) =>
  item?.name ? `${item.name} (${item[valueKey]})` : item?.[valueKey];
